import fetch from 'lib/decorated-fetch'
import handleError from './error-handle'
import getUrl from './url'
const getCarIds = async (seriesId: string, req?: any) => {
  let seriesCarIds = ''

  try {
    const json = await fetch(
      getUrl(`/motor/m_api/pc_get_series_car_ids?series_id=${seriesId}`),
      { req }
    )
    try {
      seriesCarIds = json.data?.car_ids
    } catch (err) {
      handleError(err, { req })
    }
  } catch (err) {
    // no-op
  }

  return seriesCarIds
}

export default getCarIds
